import { z } from "zod";
import { isoDateOnlySchema } from "../common/date.js";
import { phoneSchema } from "../common/phone.js";
export const selfServiceBookingSchema = z.object({
    start_date: isoDateOnlySchema,
    end_date: isoDateOnlySchema,
    num_adults: z.number().int().min(1),
    num_children: z.number().int().min(0).default(0),
    pet_count: z.number().int().min(0).optional(),
    first_name: z.string().min(1).max(100),
    last_name: z.string().min(1).max(100),
    email: z.email().toLowerCase().trim(),
    phone: phoneSchema,
    address: z.string().optional(),
});
export const tenantInfoSchema = selfServiceBookingSchema.pick({
    first_name: true,
    last_name: true,
    email: true,
    phone: true,
    address: true,
});
